import type { ComponentType, ReactNode } from 'react'
import { Card } from '@/components/ui/card'
import { IconTile } from '@/components/ui/icon-tile'
import type { IconProps } from '@/components/ui/icons'

interface Props {
  icon: ComponentType<IconProps>
  title: string
  children: ReactNode
}

export function StatusCard({ icon, title, children }: Props) {
  return (
    <Card className="p-12 text-center">
      <IconTile icon={icon} size="lg" className="mb-6" />
      <h2 className="small-headline mb-4 text-body">{title}</h2>
      {children}
    </Card>
  )
}
